import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者（法人）名",
    keyword: "contractorName",
    type: "text",
  },
  {
    explanatoryText: "解除情報",
    explanatoryTextRule: "",
    keyword: "explanatoryText",
    type: "explanatoryText",
  },
  {
    title: "解除年月日",
    keyword: "cancelDate",
    type: "text",
  },
  {
    title: "解除日における被共済職員数",
    keyword: "maStaffNum",
    type: "text",
  },

  {
    title: "解除同意書",
    keyword: "downloadLink",
    type: "nodeInLine",
  },
  {
    title: "解除の理由",
    keyword: "cancelReason",
    type: "text",
  },

  {
    title: "直近3ヶ月の退職者の証明書",
    keyword: "CertificateOfRecentThreeMonthsRetirees",
    type: "nodeInLine",
  },
];

const headTitleList: any[] = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

export { fakeTableList, headTitleList };
